// The service-account escape hatch on the client. The normal way in is
// "Sign in with Yarn" (`lib/sphinx-auth.ts`, a cookie the browser sends by
// itself); this is the optional `SPHINX_ACCESS_KEY` path for local/dev or
// scripted use. When a key is stored (localStorage `sphinx.accessKey`, or
// adopted once from `?access_key=` in the URL) every sphinx request carries it
// as `x-sphinx-access-key` and the SSE stream as `?access_key=`. Settings
// edits it.

export const SPHINX_ACCESS_KEY_STORAGE_KEY = "sphinx.accessKey";
export const SPHINX_ACCESS_KEY_HEADER = "x-sphinx-access-key";
const URL_PARAM = "access_key";

export function getSphinxAccessKey(): string | null {
  try {
    const v = localStorage.getItem(SPHINX_ACCESS_KEY_STORAGE_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function setSphinxAccessKey(key: string | null): void {
  try {
    const trimmed = key?.trim() ?? "";
    if (trimmed) localStorage.setItem(SPHINX_ACCESS_KEY_STORAGE_KEY, trimmed);
    else localStorage.removeItem(SPHINX_ACCESS_KEY_STORAGE_KEY);
  } catch {
    // storage unavailable — nothing to persist
  }
}

/** `?access_key=…` in the page URL → stored and stripped from the address bar. */
export function adoptAccessKeyFromUrl(): void {
  try {
    const url = new URL(window.location.href);
    const key = url.searchParams.get(URL_PARAM);
    if (!key) return;
    setSphinxAccessKey(key);
    url.searchParams.delete(URL_PARAM);
    window.history.replaceState(window.history.state, "", url.toString());
  } catch {
    // no window / bad URL — nothing to adopt
  }
}

/** Headers to attach to a sphinx request when a key is stored. */
export function accessKeyHeaders(): Record<string, string> {
  const key = getSphinxAccessKey();
  return key ? { [SPHINX_ACCESS_KEY_HEADER]: key } : {};
}
